import React, {FunctionComponent} from 'react';
import {Route, Routes} from "react-router";
import ProtectedRoute from '../routes/ProtectedRoute/ProtectedRoute';
import AuthorizedRoute from '../routes/AuthorizedRoute/AuthorizedRoute';
import Settings from '../pages/Settings/Settings';
import ForgotPasswordCode from '../pages/ForgotPasswordCode/ForgotPasswordCode';
import NotFound from '../pages/NotFound/NotFound';
import Dashboard from '../pages/Dashboard/Dashboard';
import "./App.css";
import ForgotPassword from '../pages/ForgotPassword/ForgotPassword';
import SignIn from '../pages/SignIn/SignIn';

import SignUp from '../pages/SignUp/SignUp';
import SignUpSuccess from '../pages/SignUpSuccess/SignUpSuccess';

import Feedback from '../components/Feedback/Feedback';
import VerifyToken from '../pages/Verify/VerifyToken';
import VerifySuccess from '../pages/VerifySuccess/VerifySuccess';
import VerifyError from '../pages/VerifyError/VerifyError';
import Logout from '../pages/Logout/Logout';
import CustomSSO from '../pages/CustomSSO/CustomSSO';
import {useTranslation} from 'react-i18next';
import CustomSSOError from '../pages/CustomSSOError/CustomSSOError';
import ForgotPasswordSuccess from '../pages/ForgotPasswordSuccess/ForgotPasswordSuccess';
import { signUpEnabledFlag } from '../feature-flags';
import SignUpComplete from '../pages/SignUpComplete/SignUpComplete';
import Imprint from '../pages/Imprint/Imprint';
import FAQ from '../pages/FAQ/FAQ';
import DashboardInfo from '../pages/DashboardInfo/Dashboardinfo';

interface Props {
}

const App: FunctionComponent<Props> = () => {

  const {t} = useTranslation( [ 'app' ] );

  return (
    <div>

      <Routes>

        <Route path="/" element={
          <AuthorizedRoute>
            <SignIn/>
          </AuthorizedRoute>
        }>
        </Route>

        <Route path="/faq" element={
          <FAQ />
        }/>
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard/>
          </ProtectedRoute>
        }/>
        <Route path="/dashboard/info/:id" element={
            <DashboardInfo/>
        }/>
        <Route path="/imprint" element={
          <Imprint />
        }/>
        <Route path="/sign-out" element={
          <Logout/>
        }></Route>
        <Route path="*" element={
          <NotFound/>
        }>
        </Route>

        {/* Custom SSO Flow */}

        <Route path="/custom-sso" element={<CustomSSO/>}></Route>
        <Route path="/:lang/custom-sso" element={<CustomSSO/>}></Route>
        <Route path="/custom-sso/error" element={<CustomSSOError/>}></Route>

        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings/>
            </ProtectedRoute>
          }/>

        {/* Change Email Flow with Token verification */}
        <Route path="/settings/verify" element={<VerifyToken />} />
        <Route path="/settings/verify/token/:token" element={<VerifyToken />} />
        <Route path="/settings/verify/success" element={<VerifySuccess/>}/>
        <Route path="/settings/verify/error" element={<VerifyError/>}/>

        {/* Forgot Password Flow */}

        <Route path="/forgot-password" element={ <ForgotPassword /> } />


        <Route path="/forgot-password/verify/" element={ <ForgotPasswordCode /> } />
        <Route path="/forgot-password/verify/:code" element={ <ForgotPasswordCode /> } />
        <Route path="/forgot-password/success" element={ <ForgotPasswordSuccess /> } />

        {/* Migration Flow */}

        { signUpEnabledFlag ? <Route path="/sign-up" element={ <SignUp /> } /> : <></> }
        { signUpEnabledFlag ? <Route path="/sign-up/success" element={ <SignUpSuccess /> }/> : <></> }
        { signUpEnabledFlag ? <Route path="/sign-up/complete" element={ <SignUpComplete /> }/> : <></> }

      </Routes>
      <Feedback/>
    </div>
  );
}

export default App;
